import { render, staticRenderFns } from "./software-technologien-6.vue?vue&type=template&id=5035b156&"
import script from "./software-technologien-6.vue?vue&type=script&lang=js&"
export * from "./software-technologien-6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports